import { translate, translateFormatter } from '@/domains/core/localization/translate';
export const seeMore = translateFormatter<{
  number: number;
  isMax: boolean;
}>("See all products {isMax, select, true {(+500)} false {({number})}}", undefined, undefined, "en");
export const {
  title
} = translate({
  "title": "Products"
});